<template>
  <v-row justify="center">
    <v-dialog v-model="isOpen" :max-width="data.maxWidth || 390" persistent>
      <v-card class="modal">
        <h2 v-html="data.text" :class="{ 'text-center': data.textCenter }"></h2>

        <div class="d-flex justify-center">
          <v-btn v-if="data.buttonText" color="primary" outlined @click="close">
            {{ data.buttonText }}
          </v-btn>
          <a
            v-if="data.signUpBtn"
            href="https://app.localzen.com/session/sign-up"
            class="ml-3"
          >
            <v-btn color="primary">
              {{ $t("message.common.signUp") }}
            </v-btn>
          </a>
          <a
            v-if="data.contactUsBtn"
            :href="contactUrl"
            target="_blank"
            class="ml-3"
          >
            <v-btn color="primary">
              {{ $t("message.common.contactWithUs") }}
            </v-btn>
          </a>
        </div>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
const CONTACT_URLS = {
  pl: "https://localzen.com/pl/kontakt/",
  en: "https://localzen.com/pl/contact/"
};
import { mapState } from "vuex";
export default {
  name: "AppModal",
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapState({
      isOpen: state => state.settings.isModalOpen
    }),
    contactUrl() {
      const language = this.$store.state.settings.selectedLocale;
      return CONTACT_URLS[language] || CONTACT_URLS["en"];
    }
  },
  methods: {
    close() {
      if (this.data.path) {
        this.$router.push({ name: this.data.path });
      }
      this.$store.dispatch("settings/closeModal");
    }
  }
};
</script>

<style lang="scss" scoped>
.modal {
  padding: $spacing * 3;

  h2 {
    @include font-size(16px);
    font-weight: $font-weight-normal;
    margin-bottom: $spacing * 4;
    line-height: 1.6rem;
  }
}
</style>
